<template>
  <div class="content my_data create_report_step if-profile edit_myData px-4">
    <PulseLoader :loading="!loaded" :class="{ hide: loaded }" quote="Action is the foundational key to all success"
      author="Pablo Picasso" profession="Spanish Painter" img="picasso.jpg"></PulseLoader>
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <nav aria-label="breadcrumb" role="navigation" class="m-0">
          <ol class="breadcrumb md-layout">
            <li class="breadcrumb-item ">
              Home
            </li>
            <li class="breadcrumb-item active md-layout-item md-medium-size-80 md-xsmall-size-80 md-size-80"
              aria-current="page">
              My Data
            </li>

          </ol>
        </nav>
        <div class="navbar md-toolbar md-transparent md-elevation-4 px-4">
          <div class="md-toolbar-section-start">
            <h1 class="section_header p-0">
              My Data
            </h1>
          </div>
          <div class="md-toolbar-section-end">
            <div v-if="this.showAddInput">
              <!-- <router-link :to="{ name: 'NewInput' }"> -->
              <md-button class="md-raised md-info md-round m-0" @click="newInputsModal = true">
                <md-icon class="ml-5">add_to_queue</md-icon> <div class="dark-blue-color">Add Inputs</div>
              </md-button>
              <!-- </router-link> -->
            </div>
            <div v-if="this.showAddInput" class="add-inpur-left">
              <md-button class="md-raised md-info md-round m-0">
                <a :href="pathToDownload" @click.prevent="downloadFile(pathToDownload)" class="href-white dark-blue-color">
                  Download CSV Template
                </a>
              </md-button>
            </div>
          </div>
        </div>



      </div>
    </div>
    <my-data-table />
    <modal class="report_inputs" v-if="newInputsModal" @close="closeYearModal()">
      <template slot="header">
        <h4 class="modal-title">Input Type</h4>

      </template>
      <template slot="body">
        <div class="modal_content">
          <div v-if="yearModalStep === 1">
            <h3 class="modal-title">Input Details</h3>

            <div class="row">
              <div class="md-layout">
                <div class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 mr-auto"
                  slot="content-right">
                  <div class="client-name-box">
                    <div>
                      <md-field>
                        <label>Description*</label>
                        <md-input type="textarea" v-model="inputDescription" />
                      </md-field>
                    </div>
                  </div>
                  <div class="client-name-box">
                    <div>
                      <md-field>
                        <label>Data Source*</label>
                        <md-input type="textarea" v-model="source" />
                      </md-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row align-div-components">
              <md-button class="md-info md-round mb-4 md-theme-default" type="button" @click="yearModalStep = 2">
                <i class="md-icon md-icon-font md-theme-default">check</i>
                Select
              </md-button>
            </div>
          </div>
          <div v-if="yearModalStep === 2">
            <h3 class="modal-title">Input Type</h3>

            <div class="md-layout">
              <input aria-label="Input CSV" type="file" ref="csvInput" accept=".csv" @change="fileSelected" style="display: none" />
              <div class="md-layout-item md-size-50">
                <div class="input_wpr" @click="chooseInputFormat('csv')">
                  <md-icon>picture_as_pdf</md-icon>
                  Add CSV
                </div>
              </div>
              <div class="md-layout-item md-size-50">
                <div class="input_wpr" @click="getDynamicInputs()">
                  <md-icon>picture_as_pdf</md-icon>
                  Form Inputs
                </div>
              </div>
            </div>
          </div>
          <div v-if="yearModalStep === 3">
            <h3 v-if="this.report !== this.constants.reportType.company.value" class="modal-title">Year
              Details</h3>

            <div v-if="this.report !== this.constants.reportType.company.value" class="field_grp">
              <md-field>
                <label>Year*</label>
                <md-select v-model="inputDataSource.year" name="pages">
                  <md-option v-for="item in yearsInput" :key="item" :label="item" :value="item">
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <h4 v-if="incomeStatementLabel">Income Statement</h4>
            <div class="field_grp">
              <md-field :key="index" v-for="(item, index) in getInputList('income_statement')">
                <label>{{ item.label }}</label>
                <md-input v-model="inputDataSource[index]" :type="item.type"></md-input>
              </md-field>
            </div>
            <h4 v-if="balanceLabel">Balance Sheet</h4>
            <div class="field_grp">
              <md-field :key="index" v-for="(item, index) in getInputList('balance_sheet')">
                <label>{{ item.label }}</label>
                <md-input v-model="inputDataSource[index]" :type="item.type"></md-input>
              </md-field>
            </div>
            <h4 v-if="employmentLabel">Employment Data</h4>
            <div class="field_grp">
              <md-field :key="index" v-for="(item, index) in getInputList('employment')">
                <label>{{ item.label }}</label>
                <md-input v-model="inputDataSource[index]" :type="item.type"></md-input>
              </md-field>
            </div>
            <h4 v-if="liabilitiesLabel">Liabilities</h4>
            <div class="field_grp">
              <md-field :key="index" v-for="(item, index) in getInputList('liabilities')">
                <label>{{ item.label }}</label>
                <md-input v-model="inputDataSource[index]" :type="item.type"></md-input>
              </md-field>
            </div>
            <h4 v-if="otherLabel">Other</h4>
            <div class="field_grp">
              <md-field :key="index" v-for="(item, index) in getInputList('other')">
                <label>{{ item.label }}</label>
                <md-input v-model="inputDataSource[index]" :type="item.type"></md-input>
              </md-field>
            </div>
            <md-button class="md-info md-round" :disabled="submitting" @click=" isCreateNewYear= true; saveNewInput();">
              <md-icon>add</md-icon>Add new Year
            </md-button>
            <md-button class="md-info md-round" :disabled="submitting" @click="isCreateNewYear = false; saveNewInput(); ">
              <md-icon>save</md-icon>Finish
            </md-button>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import { Modal, PulseLoader } from '@/components';
import CreateReportFormatConstants from '@/helpers/constants/CreateReportFormatConstants.js';
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import moment from 'moment';
import { mapActions, mapState } from 'vuex';
import MyDataTable from './_partials/MyDataTable.vue';
import axios from 'axios';

export default {
  name: 'my-data',
  components: {
    Modal,
    PulseLoader,
    MyDataTable,
  },
  data() {
    return {
      yearsHaveBeenAdded: [],
      yearsInput: ['2021', '2022', '2023', '2024', '2025'], // Fallback for non-financial report types (market/valuation/company) — not yet made automatic.
      myDataId: null,
      showAddInput: true,
      source: null,
      constants: CreateReportFormatConstants,
      report: 'financial',
      pathToDownload: window.location.origin + '/templates/my-data.csv',
      loaded: false,
      employmentLabel: false,
      balanceLabel: false,
      incomeStatementLabel: false,
      liabilitiesLabel: false,
      otherLabel: false,
      tableData: [],
      reportInputs: null,
      newInputsModal: false,
      newInputType: 'advanced',
      submitting: false,
      newInputStep: 1,
      inputDescription: '',
      inputDataSource: {},
      reportTemplate: null,
      yearModalStep: 1,
      isCreateNewYear: false,
      reportTemplateOptions: {
        financial: {
          label: 'Financial',
          value: 'financial',
        },
        market: {
          label: 'Market',
          value: 'market',
        },
        valuation: {
          label: 'Valuation',
          value: 'valuation',
        },
        company: {
          label: 'Company',
          value: 'company',
        },
      }
    };
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      defaultScreen: (state) => state?.user?.user?.preferences?.defaultScreen,
      isRetail: (state) => (state.user.user_type.retail /*|| state.user.allow_retail*/) ?true: null,
    }),
  },
  watch: {
    yearsHaveBeenAdded() {
      this.yearsInput = this.yearsInput.filter(item => !this.yearsHaveBeenAdded.includes(item));
    }
  },
  methods: {
    ...mapActions({
      registerProductExport: 'tracking/registerProductExport',
    }),
    fileSelected: async function (event) {
      await this.saveNewInput(true);

      const files = event.target.files;
      let filename = files[0].name;
      const fileReader = new FileReader();
      fileReader.addEventListener('load', () => {
        this.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      let file = files[0];

      this.uploadCSVFile(file);
    },
    uploadCSVFile: async function (file) {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      var form = new FormData();
      form.append('csv', file);
      form.append('type', 'advanced');
      form.append('my_data_id', this.myDataId);
      form.append('session_id', currentSession);

      await this.$store.dispatch('myData/csv', form).then(async (res) => {
        if (res.data.csv_data) {
          this.$router.push({ name: 'EditMyData', params: { id: this.myDataId } });
          this.$store.dispatch('alerts/success', 'Inputs added.');
        } else {
          this.$store.dispatch('alerts/error', 'Invalid CSV data format!');
        }
      });
    },
    chooseInputFormat: async function (type) {
      if (type === 'csv') {
        this.$refs.csvInput.click();
      }
    },
    checkLabel: function (label) {
      return Object.entries(this.reportInputs).some(e => e.some(el => el.section === label))
    },
    getInputList: function (type) {
      Object.filter = this.getObjectFilter();
      return Object.filter(this.reportInputs, el => el.section == type)
    },
    getObjectFilter: function () {
      return (obj, predicate) =>
        Object.keys(obj)
          .filter(key => predicate(obj[key]))
          .reduce((res, key) => (res[key] = obj[key], res), {});
    },
    checkReport: function () {
      switch (this.report) {
        case this.constants.reportType.financial.value:
          return this.constants.financialReportInputs;

        case this.constants.reportType.market.value:
          return this.constants.marketReportInputs;

        case this.constants.reportType.company.value:
          return this.constants.companyReportInputs;

        case this.constants.reportType.valuation.value:
          return this.constants.valuationReportInputs;
      }
    },
    getDynamicInputs: function () {
      this.yearModalStep = 3;

      this.reportInputs = this.checkReport()

      this.employmentLabel = this.checkLabel('employment');
      this.balanceLabel = this.checkLabel('balance_sheet');
      this.incomeStatementLabel = this.checkLabel('income_statement');
      this.liabilitiesLabel = this.checkLabel('liabilities');
      this.otherLabel = this.checkLabel('other');
    },
    selectReportType: function (type) {
      this.report = type;
      this.yearModalStep = 2;
    },
    closeYearModal: function () {
      this.newInputsModal = false;
    },
    downloadFile(file) {
      axios.get(file, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'text/csv' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = 'my-data.csv'
          link.click()
          URL.revokeObjectURL(link.href)
        }).catch()
      this.registerProductExport({
          userId: this.auth_user?.user?.userID,
          productId: this.$route.params.id,
          exportType: 'CSV'
      })
    },
    closeNewInputsModal: function () {
      this.newInputsModal = false;
      this.newInputStep = 1;
    },
    saveNewInput: async function (isCSV = false) {
      // Guard against double-fire (double-click / second call before the API
      // responds): without it, a second call still sees myDataId == null and
      // dispatches myData/add again, creating a duplicate dataset.
      if (this.submitting) return;
      this.submitting = true;

      try {
        let currentSession = localStorage.getItem(
          'vue-authenticate.vueauth_access_token'
        );
        let params = {
          session_id: currentSession,
          type: 'advanced',
          description: this.inputDescription,
          data_source: this.source,
        };

        if(!this.myDataId )
          await this.$store.dispatch('myData/add', params).then(async (res) => {
            const myData = res.data.my_data;
            this.myDataId = myData.id;

            await this.postCreateYear(false)

            this.$store.dispatch('alerts/success', 'Data created.');
          });
        else
          await this.postCreateYear(true)
      } finally {
        this.submitting = false;
      }
    },
    postCreateYear: async function (newYear) {
      
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      let myDataId =  this.myDataId;
      let createData = this.inputDataSource;
      createData.myDataId = myDataId;
     
      let params = {
        type: 'advanced',
        session_id: currentSession,
        data: createData,
      };
      this.yearsHaveBeenAdded.push(createData.year);
      await this.$store.dispatch('year/add', params).then((res) => {
        if(!this.isCreateNewYear)
          this.$router.push({ name: 'EditMyData', params: { id: this.myDataId } });
        else  
          this.inputDataSource = {};  
      
        this.$store.dispatch('alerts/success', 'Year created.');
      });
    },

    deleteMyData: async function (id) {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      let params = {
        session_id: currentSession,
        my_data_id: id,
      };

      await this.$store.dispatch('myData/destroy', params).then((res) => {
        this.$store.dispatch('alerts/success', 'Data deleted.');
        this.getAllMyData();
      });
    },
    getAllMyData: async function () {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      this.loaded = false;

      let params = {
        session_id: currentSession,
      };

      await this.$store.dispatch('myData/list', params).then((res) => {
        
        if(res.data.my_data.length>=1 && this.isRetail)
          this.showAddInput = false;

        let myData = res;
        this.parseTableData(myData);
        this.loaded = true;
      });
    },
    parseTableData: async function (myData) {
      this.tableData = [];

      myData.data.my_data.forEach((data, index) => {
        this.tableData.push({
          dateCreated: moment(data.dateCreated).format('YYYY-MM-DD'),
          dateModified: moment(data.dateUpdated).format('YYYY-MM-DD'),
          dataSource: data.dataSource,
          description: data.description,
          inputsType: data.type,
          products: '',
          id: data.id,
        });
      });
    },
  },
  async created() {
    await this.getAllMyData();
    if (this.report === 'financial') {
      await this.$store.dispatch('ifRelease/fetchIfReleaseYears');
      this.yearsInput = this.$store.getters['ifRelease/years'] || this.yearsInput;
    }
  },
};
</script>
<style lang="scss">
.search-box input,
.client-name-box input,
.client-name-box textarea {
  width: 100%;
}

.client-name-box>div {
  width: 100%;
}
</style>
